"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfigProvider = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _context = require("./context");
var _LocaleProvider = require("../LocaleProvider");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var ConfigProvider = function ConfigProvider(props) {
  var messages = props.messages,
    modals = props.modals,
    eventEmitter = props.eventEmitter,
    container = props.container,
    rootId = props.rootId,
    translations = props.translations,
    tracker = props.tracker,
    children = props.children,
    locale = props.locale,
    locales = props.locales,
    region = props.region,
    dontUseBodyAsDefaultContainer = props.dontUseBodyAsDefaultContainer;
  var _useState = (0, _react.useState)(10),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    modalZIndex = _useState2[0],
    setModalZIndex = _useState2[1];
  var increaseModalZIndex = function increaseModalZIndex() {
    setModalZIndex(modalZIndex + 1);
  };
  _context.dataMaintainer.updateTracker(tracker);
  return /*#__PURE__*/_react.default.createElement(_context.ConfigContext.Provider, {
    value: {
      messages: messages,
      eventEmitter: eventEmitter,
      rootId: rootId,
      translations: translations,
      container: container,
      modalZIndex: modalZIndex,
      increaseModalZIndex: increaseModalZIndex,
      modals: modals,
      dontUseBodyAsDefaultContainer: dontUseBodyAsDefaultContainer
    }
  }, /*#__PURE__*/_react.default.createElement(_LocaleProvider.LocaleProvider, {
    locale: locale,
    locales: locales,
    region: region
  }, children));
};
exports.ConfigProvider = ConfigProvider;